import React from 'react';
import {ScrollView, StyleSheet, Text, TouchableOpacity} from 'react-native';
import {useTranslation} from 'react-i18next';
import {useManagementTheme} from '../helpers/managementTheme';

const KINDS = ['all', 'standard', 'vehicle'];

/**
 * All / Standard / Mobile warehouse filter chips (same look as the chips of the
 * management warehouse list). Purely presentational: the parent filters locally
 * with `filterWarehousesByKind`.
 *
 * @param {object} props
 * @param {'all'|'standard'|'vehicle'} props.value Active kind.
 * @param {(kind: string) => void} props.onChange Selection handler.
 * @param {object} [props.style] Extra style for the scroll row.
 * @returns {JSX.Element} The chip row.
 */
const WarehouseKindChips = ({value, onChange, style}) => {
    const {t} = useTranslation();
    const m = useManagementTheme();

    return (
        <ScrollView horizontal showsHorizontalScrollIndicator={false} style={[styles.scroll, style]} contentContainerStyle={styles.row}>
            {KINDS.map((kind) => {
                const active = kind === value;

                return (
                    <TouchableOpacity
                        key={kind}
                        onPress={() => onChange(kind)}
                        activeOpacity={0.85}
                        accessibilityRole="button"
                        accessibilityState={{selected: active}}
                        style={[
                            styles.chip,
                            {backgroundColor: active ? m.colors.chipBg : m.colors.surface, borderColor: active ? m.colors.primary : m.colors.border},
                        ]}
                    >
                        <Text style={[styles.chipText, {color: active ? m.colors.primary : m.colors.subText}]} numberOfLines={1}>
                            {t(`mgmt_list_warehouses_filter_${kind === 'vehicle' ? 'mobile' : kind}`)}
                        </Text>
                    </TouchableOpacity>
                );
            })}
        </ScrollView>
    );
};

const styles = StyleSheet.create({
    scroll: {flexGrow: 0},
    row: {gap: 8, paddingRight: 4},
    chip: {borderRadius: 999, borderWidth: 1.2, paddingHorizontal: 15, paddingVertical: 9},
    chipText: {fontSize: 12.5, fontWeight: '800'},
});

export default WarehouseKindChips;
